import {
	changedRatio,
	DIFF_COLLAPSE,
	shouldCollapseParagraph,
	shouldCollapseSentence,
	wordsOf,
} from "@ext/git/core/Diff/logic/collapseThresholds";
import type { DiffChange } from "@gaurussel/tiptap-diff-utility";

const shouldCollapse = (change: DiffChange, threshold: number = DIFF_COLLAPSE.ratio): boolean => {
	if (change.type === "deleted") return true;
	if (change.type !== "modified") return false;

	const before = change.nodeA?.textContent ?? "";
	const after = change.nodeB?.textContent ?? "";

	if (before === after) return false;

	// Before the sentence check: a period inserted mid-phrase splits one sentence in two
	// and would read as a rewrite.
	if (changedRatio(wordsOf(before), wordsOf(after)) === 0) return false;

	return shouldCollapseParagraph(before, after, threshold) || shouldCollapseSentence(before, after, threshold);
};

export default shouldCollapse;
